import { mapState, mapMutations } from 'vuex';
import { fetchRetry } from '@/utils/api/fetchRetry';
import axios from 'axios';

export default {
  computed: {
    ...mapState('loginGeneral', ['user']),
    ...mapState('mediaGeneral', ['userPlaylists']),
  },
  methods: {
    ...mapMutations('mediaGeneral', ['setUserPlaylists']),
    async setUpUserPlaylists() {
      try {
        this.setUserPlaylists();
        const userPlaylists = await this.fetchUserPlaylists();
        if (!userPlaylists || !userPlaylists.length) {
          const defaultPlaylist = await this.createNewPlaylist({ user_id: this.user.id, name: 'Mis Favoritos' });
          if (defaultPlaylist) {
            defaultPlaylist.isSelected = false;
            defaultPlaylist.plays =
              defaultPlaylist.playslists || defaultPlaylist.playlist || defaultPlaylist.playlists || [];
            this.userPlaylists.push(defaultPlaylist);
          }
        } else {
          this.userPlaylists.push(
            ...userPlaylists.map(playlist => {
              playlist.isSelected = false;
              playlist.plays = playlist.playlists || playlist.playlist || [];
              return playlist;
            }),
          );
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async fetchUserPlaylists() {
      try {
        // console.log('********** fetchUserPlaylists **********');
        // console.log(this.user);
        const response = await fetchRetry({
          url: `https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/${this.user.id}/playlists`,
        });
        return response.data && response.data.playlists ? response.data.playlists : [];
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     *
     * @param {Object} body
     * @param {Number} body.user_id
     * @param {String} body.name
     * @param {String=} body.description
     * @param {String=} body.icon
     * @return {Promise<void>}
     */
    async createNewPlaylist(body) {
      let response = {};
      try {
        // eslint-disable-next-line no-undef
        response = await axios.post(
          'https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/playlists',
          body,
        );
        return response.data && response.data.playlist ? response.data.playlist : null;
      } catch (e) {
        this.showError(e.response.data.message);
        return Promise.reject(e);
      }
    },
    unselectPlaylists() {
      this.userPlaylists.forEach(playlist => {
        playlist.isSelected = false;
      });
    },
  },
};
